"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RegistrationDto = /** @class */ (function () {
    function RegistrationDto() {
    }
    return RegistrationDto;
}());
exports.default = RegistrationDto;
